class TourSchedule {
  constructor() {
    this.init();
  }

  init() {
    this.tour_schedule_id = undefined;
    this.center_id = undefined;
    this.age_group_id = undefined;
    this.start_time = undefined;
    this.end_time = undefined;
    this.day_of_week = undefined;
    this.exact_date = undefined;
    this.duration = undefined;
    this.capacity = undefined;
    this.virtual = undefined;

    // Read only properties
    this.age_group_name = undefined;
  }

  copy() {
    const cp = new TourSchedule();

    cp.tour_schedule_id = this.tour_schedule_id;
    cp.center_id = this.center_id;
    cp.age_group_id = this.age_group_id;
    cp.start_time = this.start_time;
    cp.end_time = this.end_time;
    cp.day_of_week = this.day_of_week;
    cp.exact_date = this.exact_date;
    cp.duration = this.duration;
    cp.capacity = this.capacity;
    cp.age_group_name = this.age_group_name;
    cp.virtual = this.virtual;

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.tour_schedule_id = obj.tour_schedule_id ? obj.tour_schedule_id.toString() : undefined;
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.age_group_id = obj.age_group_id ? obj.age_group_id.toString() : undefined;
      this.start_time = obj.start_time ? obj.start_time : undefined;
      this.end_time = obj.end_time ? obj.end_time : undefined;
      this.day_of_week = (obj.day_of_week || (obj.day_of_week === 0)) ? obj.day_of_week : undefined;
      this.duration = obj.duration ? obj.duration : undefined;
      this.capacity = obj.capacity ? obj.capacity : undefined;
      this.virtual = (obj.virtual === undefined) || (obj.virtual === null) ? undefined : obj.virtual;
      this.age_group_name = obj.age_group_name ? obj.age_group_name : undefined;
      if (obj.exact_date) {
        this.exact_date = new Date(obj.exact_date);
      } else {
        this.exact_date = undefined;
      }
    }
  }

  toString() {
    let result = this.tour_schedule_id ? this.tour_schedule_id : '';
    return result;
  }

  getId() {
    return this.tour_schedule_id;
  }

  setId(tour_schedule_id) {
    this.tour_schedule_id = tour_schedule_id ? tour_schedule_id.toString() : undefined;
  }

  getAgeGroupId() {
    return this.age_group_id;
  }
  
  setAgeGroupId(age_group_id) {
    this.age_group_id = age_group_id ? age_group_id.toString() : undefined;
  }

  getCenterId() {
    return this.center_id;
  }

  setCenterId(center_id) {
    this.center_id = center_id ? center_id.toString() : undefined;
  }

  getStartHour() {
    return (this.start_time !== undefined) ? Math.floor(this.start_time / 60) : undefined;
  }

  setStartHour(hour) {
    this.start_time = (hour === undefined) ? undefined :
      (this.start_time === undefined) ? (hour * 60) : ((hour * 60) + this.start_time % 60);
  }

  getStartMinute() {
    return (this.start_time !== undefined) ? Math.floor(this.start_time % 60) : undefined;
  }

  setStartMinute(minute) {
    this.start_time = (minute === undefined) ? undefined :
      (this.start_time === undefined) ? minute : (60 * Math.floor(this.start_time / 60) + minute);
  }

  getEndHour() {
    return (this.end_time !== undefined) ? Math.floor(this.end_time / 60) : undefined;
  }

  setEndHour(hour) {
    this.end_time = (hour === undefined) ? undefined :
      (this.end_time === undefined) ? (hour * 60) : ((hour * 60) + this.end_time % 60);
  }

  getEndMinute() {
    return (this.end_time !== undefined) ? Math.floor(this.end_time % 60) : undefined;
  }

  setEndMinute(minute) {
    this.end_time = (minute === undefined) ? undefined :
      (this.end_time === undefined) ? minute : (60 * Math.floor(this.end_time / 60) + minute);
  }

  getDayOfWeek() {
    return this.day_of_week;
  }

  setDayOfWeek(day_of_week) {
    this.day_of_week = day_of_week;
  }

  getExactDate() {
    return this.exact_date;
  }

  setExactDate(exact_date) {
    if (exact_date) {
      this.exact_date = new Date(exact_date);
      this.exact_date.setHours(0);
      this.exact_date.setMinutes(0);
      this.exact_date.setSeconds(0);
      this.exact_date.setMilliseconds(0);
    } else {
      this.exact_date = undefined;
    }
  }

  getDuration() {
    return this.duration;
  }

  setDuration(duration) {
    this.duration = duration;
  }

  getCapacity() {
    return this.capacity;
  }

  setCapacity(capacity) {
    this.capacity = capacity;
  }

  getVirtual() {
    return this.virtual;
  }

  setVirtual(virtual) {
    this.virtual = virtual;
  }

  // Read only properties
  getAgeGroupName() {
    return this.age_group_name;
  }
}

module.exports = TourSchedule;
